import React from "react"

export const ListItemChecked: React.FC = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6836 6.89712C16.8344 7.03151 16.841 7.25564 16.6984 7.39775L8.97751 15.0895C8.90776 15.159 8.81114 15.1989 8.70964 15.2003C8.60814 15.2016 8.51038 15.1642 8.4386 15.0966L4.31127 11.2082C4.16447 11.0699 4.16447 10.8457 4.31127 10.7074C4.45807 10.5691 4.69607 10.5691 4.84286 10.7074L8.69687 14.3383L16.1522 6.9111C16.2948 6.769 16.5327 6.76274 16.6836 6.89712Z"
        fill="white"
      />
    </svg>
  )
}
